import React, {useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    closeModal,
    CONFIRMATION_MODAL,
    COURSE_MEMBERSHIP_MODAL, COURSE_PARTIAL_DAYS_MODAL,
    FORGOT_PASSWORD_MODAL, KIOSK_TOKEN_VERIFY_MODAL,
    LOGIN_MODAL,
    MOBILE_MENU_DRAWER,
    ONE_TIME_PASSWORD_MODAL,
    REDIRECT_LOADER_MODAL,
    SELECT_DATE_MODAL, SELECT_QUANTITY_MODAL, SEND_EMAIL_MODAL,
    SESSION_MEMBERSHIP_MODAL,
    SHOP_ITEM_MODAL,
    TRIAL_COURSE_SESSION_MODAL,
    WAITLIST_DONT_WANT_SLOT_MODAL,
    LINK_EXISTING_MODAL
} from "@arboxappv4/shared/src/redux/modalManagerSlice";
import Login from "./login/Login";
import MobileMenu from "./mobileMenu/MobileMenu";
import ForgotPassword from "./login/ForgotPassword";
import SelectDate from "./selectDate/SelectDate";
import OneTimePassword from "./login/OneTimePassword";
import ConfirmationModal from "./ConfirmationModal";
import SessionMembershipSelect from "./sessionMembershipSelect/SessionMembershipSelect";
import ShopItemModal from "./shopItem/ShopItemModal";
import CourseMembershipSelect from "./sessionMembershipSelect/CourseMembershipSelect";
import TrialCourseSessionSelect from "./sessionMembershipSelect/TrialCourseSessionSelect";
import SelectQuantity from "./selectQuantity/SelectQuantity";
import CoursePartialBookingDaysSelect from "./sessionMembershipSelect/CoursePartialBookingDaysSelect";
import KioskTokenValidateModal from "./kioskTokenValidate/KioskTokenValidateModal";
import RedirectLoader from "./redirect/RedirectLoader";
import SendEmail from "./sendEmail/SendEmail";
import WaitlistDontWantSlotModal from "./waitlistDontWantSlot/WaitlistDontWantSlotModal";
import LinkExistingModal from "./linkExisting/LinkExistingModal";

const ModalManager = (props) => {
    const { } = props;
    const loginModal = useSelector(state => state.modalManager[LOGIN_MODAL])
    const mobileMenuDrawer = useSelector(state => state.modalManager[MOBILE_MENU_DRAWER])
    const forgotPasswordModal = useSelector(state => state.modalManager[FORGOT_PASSWORD_MODAL])
    const selectDateModal = useSelector(state => state.modalManager[SELECT_DATE_MODAL])
    const oneTimePasswordModal = useSelector(state => state.modalManager[ONE_TIME_PASSWORD_MODAL])
    const confirmationModal = useSelector(state => state.modalManager[CONFIRMATION_MODAL])
    const sessionMembershipModal = useSelector(state => state.modalManager[SESSION_MEMBERSHIP_MODAL])
    const shopItemModal = useSelector(state => state.modalManager[SHOP_ITEM_MODAL])
    const courseMembershipModal = useSelector(state => state.modalManager[COURSE_MEMBERSHIP_MODAL])
    const trialCourseSessionModal = useSelector(state => state.modalManager[TRIAL_COURSE_SESSION_MODAL])
    const selectQuantityModal = useSelector(state => state.modalManager[SELECT_QUANTITY_MODAL])
    const selectPartialDaysModal = useSelector(state => state.modalManager[COURSE_PARTIAL_DAYS_MODAL])
    const kioskTokenVerifyModal = useSelector(state => state.modalManager[KIOSK_TOKEN_VERIFY_MODAL])
    const redirectLoaderModal = useSelector(state => state.modalManager[REDIRECT_LOADER_MODAL])
    const sendEmailModal = useSelector(state => state.modalManager[SEND_EMAIL_MODAL])
    const waitlistDontWantSlotModal = useSelector(state => state.modalManager[WAITLIST_DONT_WANT_SLOT_MODAL])
    const linkExistingModal = useSelector(state => state.modalManager[LINK_EXISTING_MODAL])

    const modals = useMemo(() => ({
        [LOGIN_MODAL]: loginModal,
        [MOBILE_MENU_DRAWER]: mobileMenuDrawer,
        [FORGOT_PASSWORD_MODAL]: forgotPasswordModal,
        [SELECT_DATE_MODAL]: selectDateModal,
        [ONE_TIME_PASSWORD_MODAL]: oneTimePasswordModal,
        [CONFIRMATION_MODAL]: confirmationModal,
        [SESSION_MEMBERSHIP_MODAL]: sessionMembershipModal,
        [SHOP_ITEM_MODAL]: shopItemModal,
        [COURSE_MEMBERSHIP_MODAL]: courseMembershipModal,
        [TRIAL_COURSE_SESSION_MODAL]: trialCourseSessionModal,
        [SELECT_QUANTITY_MODAL]: selectQuantityModal,
        [COURSE_PARTIAL_DAYS_MODAL]: selectPartialDaysModal,
        [KIOSK_TOKEN_VERIFY_MODAL]: kioskTokenVerifyModal,
        [REDIRECT_LOADER_MODAL]: redirectLoaderModal,
        [SEND_EMAIL_MODAL]: sendEmailModal,
        [WAITLIST_DONT_WANT_SLOT_MODAL]: waitlistDontWantSlotModal,
        [LINK_EXISTING_MODAL]: linkExistingModal,
    }),[loginModal, kioskTokenVerifyModal, redirectLoaderModal, sendEmailModal, waitlistDontWantSlotModal, linkExistingModal])
    const dispatch = useDispatch()

    const onClose = (modalName, props = {}) => {
        dispatch(closeModal({modalName: modalName}))
        if(modals[modalName]?.onClose) setTimeout(() => modals[modalName].onClose({...props}), 100)
    }

    return (
        <>
            {loginModal.isOpen && <Login isOpen={loginModal.isOpen && !loginModal.hide} onClose={() => onClose(LOGIN_MODAL)} {...loginModal.props}/>}
            {mobileMenuDrawer.isOpen && <MobileMenu isOpen={mobileMenuDrawer.isOpen} onClose={() => onClose(MOBILE_MENU_DRAWER)} {...mobileMenuDrawer.props}/>}
            {forgotPasswordModal.isOpen && <ForgotPassword isOpen={forgotPasswordModal.isOpen} onClose={() => onClose(FORGOT_PASSWORD_MODAL)} {...forgotPasswordModal.props}/>}
            {selectDateModal.isOpen && <SelectDate isOpen={selectDateModal.isOpen} onClose={() => onClose(SELECT_DATE_MODAL)} {...selectDateModal.props}/>}
            {oneTimePasswordModal.isOpen && <OneTimePassword isOpen={oneTimePasswordModal.isOpen} onClose={() => onClose(ONE_TIME_PASSWORD_MODAL)} {...oneTimePasswordModal.props}/>}
            {confirmationModal.isOpen && <ConfirmationModal isOpen={confirmationModal.isOpen} onClose={() => onClose(CONFIRMATION_MODAL)} {...confirmationModal.props}/>}
            {sessionMembershipModal.isOpen && <SessionMembershipSelect isOpen={sessionMembershipModal.isOpen} onClose={() => onClose(SESSION_MEMBERSHIP_MODAL)} {...sessionMembershipModal.props}/>}
            {shopItemModal.isOpen && <ShopItemModal isOpen={shopItemModal.isOpen} onClose={() => onClose(SHOP_ITEM_MODAL)} {...shopItemModal.props}/>}
            {courseMembershipModal.isOpen && <CourseMembershipSelect isOpen={courseMembershipModal.isOpen} onClose={() => onClose(COURSE_MEMBERSHIP_MODAL)} {...courseMembershipModal.props}/>}
            {trialCourseSessionModal.isOpen && <TrialCourseSessionSelect isOpen={trialCourseSessionModal.isOpen} onClose={() => onClose(TRIAL_COURSE_SESSION_MODAL)} {...trialCourseSessionModal.props}/>}
            {selectQuantityModal.isOpen && <SelectQuantity isOpen={selectQuantityModal.isOpen} onClose={() => onClose(SELECT_QUANTITY_MODAL)} {...selectQuantityModal.props}/>}
            {selectPartialDaysModal.isOpen && <CoursePartialBookingDaysSelect isOpen={selectPartialDaysModal.isOpen} onClose={() => onClose(COURSE_PARTIAL_DAYS_MODAL)} {...selectPartialDaysModal.props}/>}
            {kioskTokenVerifyModal.isOpen && <KioskTokenValidateModal isOpen={kioskTokenVerifyModal.isOpen && !kioskTokenVerifyModal.hide} onClose={(props) => onClose(KIOSK_TOKEN_VERIFY_MODAL, props)} {...kioskTokenVerifyModal.props}/>}
            {redirectLoaderModal.isOpen && <RedirectLoader isOpen={redirectLoaderModal.isOpen} onClose={() => onClose(REDIRECT_LOADER_MODAL)} {...redirectLoaderModal.props}/>}
            {sendEmailModal.isOpen && <SendEmail isOpen={sendEmailModal.isOpen} onClose={() => onClose(SEND_EMAIL_MODAL)} {...sendEmailModal.props}/>}
            {waitlistDontWantSlotModal.isOpen && <WaitlistDontWantSlotModal isOpen={waitlistDontWantSlotModal.isOpen} onClose={() => onClose(WAITLIST_DONT_WANT_SLOT_MODAL)} {...waitlistDontWantSlotModal.props}/>}
            {linkExistingModal.isOpen && <LinkExistingModal isOpen={linkExistingModal.isOpen} onClose={() => onClose(LINK_EXISTING_MODAL)} {...linkExistingModal.props}/>}
        </>
    );
};

export default ModalManager;